import PropTypes from 'prop-types'
import React from 'react'

const Checkbox = React.forwardRef((props, ref) => {
  const { name, className, disabled, errores, ...rest } = props
  const error = errores && errores[name]
  const obtenerClasesInput = () =>
    disabled ? 'disabled' : error ? `${className} error` : className

  return (
    <>
      <input
        {...rest}
        type="checkbox"
        ref={ref}
        name={name}
        id={name}
        className={obtenerClasesInput()}
        disabled={disabled}
        aria-disabled={disabled}
      />
      {error && (
        <div className="alert alert-danger mt-1" role="alert">
          {error}
        </div>
      )}
    </>
  )
})

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errores: PropTypes.object
}

Checkbox.displayName = 'Checkbox'

export default Checkbox
